export const makeAllObjectsNonErasable = () => {
  const objects = window.canvas.getObjects();

  for (const obj of objects) {
    obj.set('erasable', false);
  }

  if (window.canvas.backgroundImage) {
    window.canvas.backgroundImage.set('erasable', false);
  }

  window.canvas.renderAll();
};
